export default __webpack_public_path__ + "static/batisseStas-tablet-325d052b04965c28d5da289f895fab2b.webp";